import { DestroyRef, Directive, Input, OnInit, Optional, TemplateRef, ViewContainerRef } from '@angular/core';
import { takeUntilDestroyed } from '@angular/core/rxjs-interop';
import { ControlContainer } from '@angular/forms';

@Directive({
    selector: '[ifNotDisabled]',
    standalone: true,
})
export class IfNotDisabledDirective implements OnInit {
    private hasView = false;

    @Input() ifNotDisabled?: string;

    constructor(
        private templateRef: TemplateRef<any>,
        private viewContainer: ViewContainerRef,
        @Optional() private controlContainer: ControlContainer,
        private destroyRef: DestroyRef,
    ) {}

    public ngOnInit() {
        this.setupControlStatusListener();
    }

    private setupControlStatusListener() {
        if (this.controlContainer && this.ifNotDisabled) {
            const control = this.controlContainer.control?.get(this.ifNotDisabled);

            if (control) {
                // Subscribe to status changes of the control
                control.statusChanges.pipe(takeUntilDestroyed(this.destroyRef)).subscribe(() => {
                    this.updateView();
                });
                // Initial check
                this.updateView();
            }
        }
    }

    private updateView(): void {
        if (!this.controlContainer || !this.ifNotDisabled) {
            this.clearView();
            return;
        }

        const control = this.controlContainer.control?.get(this.ifNotDisabled);

        if (control && !control.disabled) {
            this.createView();
        } else {
            this.clearView();
        }
    }

    private createView(): void {
        if (!this.hasView) {
            this.viewContainer.createEmbeddedView(this.templateRef);
            this.hasView = true;
        }
    }

    private clearView(): void {
        if (this.hasView) {
            this.viewContainer.clear();
            this.hasView = false;
        }
    }
}
